module.exports = __webpack_public_path__ + "img/ic_help_outline-16px@2x.7ab2bd8a.png";